import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { StatusLayout } from '../components/layout/StatusLayout';

export const LoadingPage = () => (
  <StatusLayout>
    <FontAwesomeIcon icon="spinner" pulse className="spinner" />
  </StatusLayout>
);
